import selectn from 'selectn'
import { common } from '../../common'
export const helpers = {
  /**
  * Get all Team's stats info in one single array insted of grouping into pools just to ease ranking based on some stats
  * @param  {Array} standingsData Teams grouped into pools
  * @return {Array}  one single array having all Team's stats by removing the grouping
  */
  getProcessedStats(standingsData = []) {
    let processedStats = []
    if(!standingsData) {
      return
    }
    standingsData.map((s) => {
      let entries = selectn('standings.entries',s) || []
      entries.map((entry) => { 
        let stats = {}      
        if(entry.stats) {
          entry.stats.map((stat) => {
            stats[stat.type] = stat
          })
        }
        processedStats.push({
          stats : stats,
          team : entry.team
        })
      })
    })
    return processedStats
  },
  
  /**
  * Get Current Team stats and Highest Team stats by comparing standings accross all the teams
  * @param  {Array} stats processed stats having data of all the teams
  * @param {String} statName Name of the stat based on which the comparison need to be done
  * @param {Number} homeTeamId Id of the team on which user is landing
  * @return {Object}  Object having some flags and selected Team Stats along with Team ranking first based on current Stat
  */
  getStatComparison(stats=[], statName, homeTeamId ) {
    let sortedStats = []
    //push all the stats into sortedStats to avoid manupulation of source array and extract obnly the stat required for comparison
    for(let i=0; i < stats.length; i++) {
      sortedStats.push({ team: stats[i].team, stats:stats[i].stats[statName] || {} })
    }

    //sort in descending order based on statName
    sortedStats.sort((a, b) => {
      let aVal = selectn('stats.value', a) || 0
      let bVal = selectn('stats.value', b) || 0
      return (bVal-aVal)
    })

    // add ranking to all the teams ordered from max to min
    sortedStats.map(function (s, index) {
      s.rank = index + 1
      return s
    })

    // handle ranking for dupes
    sortedStats = this.getRankingForDups(sortedStats)

    // extract stats of selected team based on homeTeamId param
    let homeTeamStats = {}
    for(let i=0; i<sortedStats.length; i++) {
      let ithStat = sortedStats[i]
      if(selectn('team.id',ithStat) == homeTeamId) {
        homeTeamStats = ithStat
      }
    }
    let awayTeamStats = {}
    // extract all the Teams ranked first in the sorted array
    const firstRankTeams = sortedStats.filter((a) => {
      return a.rank == 1
    })
    let isTied = false
    let isOnlyMax = false

    // check if only one team ranked first, if so and current team itself is top then update accordingly
    if(firstRankTeams.length == 1) {
      if(homeTeamStats.rank == 1) {
        isOnlyMax = true
      }
      else {
        awayTeamStats = firstRankTeams[0]
      }
    }
    // if morethan one team ranked first then sort all first rank teams in alphabetical order
    //extract the first element of array which is a team landed by user
    // if current team is also one of the teams ranked first then update the flags
    else {
    // sort first ranked teams based on alphabetical order
      firstRankTeams.sort( (prev, next) => {
        let prevName = selectn('team.name', prev) || ''
        let nextName = selectn('team.name', next) || ''
        return (prevName.localeCompare(nextName))
      })
      if(homeTeamStats.rank != 1) {
        awayTeamStats = firstRankTeams[0]
      }
      else {
        let maxStatVal = selectn('[0].stats.value',firstRankTeams)
        if(maxStatVal > 0) {
          isTied = true
        }        
        for(let i=0; i < firstRankTeams.length; i++) {
          if(selectn('team.id', firstRankTeams[i]) != homeTeamId) {
            awayTeamStats = firstRankTeams[i]
            break
          }
        }
      }
    }
    return { 
      isTied, 
      isOnlyMax, 
      homeTeam : {        
        ...homeTeamStats.team,
        rank: homeTeamStats.rank,
        rankMarkup : this.getOrdinalSuffix(homeTeamStats.rank),
        stats : selectn('stats.value', homeTeamStats) || 0,
        teamLogo : common.getTeamLogo(homeTeamStats.team)
      },
      awayTeam : isOnlyMax ? '' : { 
        ...awayTeamStats.team || {},
        rank: awayTeamStats.rank || 0,
        rankMarkup: this.getOrdinalSuffix(awayTeamStats.rank),
        stats : selectn('stats.value', awayTeamStats) || 0,
        teamLogo : common.getTeamLogo(awayTeamStats.team)
      }
    }
  },

  /**
  * When teams are given with a rank there might be ties. This method will handle all those ties and rectify ranking accordingly
  * @param {Array} stats array of stats ordered in descending order along with ranking but not handled for dupes
  * @return {Array} array of stats ordered in descending order along with ranking handled for dupes
  */
  getRankingForDups(stats) {
    // only sorted stats having a rank property already
    let sortedStats = stats
    var counter = 1
    for (var k = 0; k < sortedStats.length-1; k++) {
      if(selectn('stats.value',sortedStats[k]) == selectn('stats.value',sortedStats[k+1])) {
        sortedStats[k+1].rank = sortedStats[k].rank
        counter++
      }
      else {
        sortedStats[k+1].rank = sortedStats[k].rank + counter
        counter = 1
      }
    }
    return sortedStats
  },
  /**
  * get markup for team rank along with respective <sup></sup> tags Eg : 1<sup>st<sup>
  * @param {Number} rank rank for which markup is required
  * @return {String} conditionally framed markup for rank
  */
  getOrdinalSuffix(rank = 0) {
    let markup = ''
    if(isNaN(rank) || rank == 0) {
      return ''
    }
    const j = rank % 10
    const k = rank % 100
    if(j === 1 && k !== 11) {
      markup = '1<sup>st</sup>'
    }
    else if(j === 2 && k !== 12) {
      markup = '2<sup>nd</sup>'
    }
    else if(j === 3 && k !== 13) {
      markup = '3<sup>rd</sup>'
    }
    else {
      markup = `${rank}<sup>th</sup>`
    }
    return markup
  },

  /**
  * get conditionally built subheading for chart module based on some flags
  * @param {Object} homeTeam stats of team on which user has landed
  * @param {Object} awayTeam stats of Team ranked first
  * @param {Boolean} isTied flag that indicates if selected Team is tied with team ranked first
  * @param {Boolean} isOnlyMax flag that indicates if selected team is the only team rankled first
  * @param {String} text indicating for what type of stat the subheading need to be framed
  * @return {String} conditionally framed subheading based on all inputs
  */
  getChartSubHeading({ homeTeam = {}, awayTeam = {}, isTied, isOnlyMax , type = '' }) {
    let subHeading = ''
    if(isTied) {
      subHeading = `${homeTeam.shortDisplayName || homeTeam.displayName} tied in ${this.getOrdinalSuffix(homeTeam.rank)} with ${awayTeam.shortDisplayName || awayTeam.displayName}`
    }
    else if(isOnlyMax) {
      subHeading = ''
    }
    else {
      subHeading = `${this.getOrdinalSuffix(awayTeam.rank)} ${awayTeam.shortDisplayName || awayTeam.displayName} : ${awayTeam.stats} ${type}`
    }
    return subHeading
  },

  /**
  * Build 'Full Statistics' link based on team Id
  * @param {Number} teamId Id of team on whcih user has landed
  * @return {String} full url of statsguru page built from teamId
  */
  getStatsguruLink(teamId) {
    if(teamId) {
      return `http://en.espn.co.uk/statsguru/rugby/team/${teamId}.html?class=1;type=team`
    }
    else {
      return '#'
    }
  }
}

export default helpers



/** WEBPACK FOOTER **
 ** ../app/lib/transform/parsers/rugby/clubhouse/helpers.js
 **/